// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import { Button } from 'ui'
import GlyphBorder from './GlyphBorder'

function HoverButton(props) {
  return (
    <div className={props.className}>
      <GlyphBorder show={props.show}>
        <Button
          variant="link"
          onClick={props.onClick}
          style={{
            padding: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {props.children}
        </Button>
      </GlyphBorder>
    </div>
  );
}

export default HoverButton;
